<div class="card topic-card">
  <div class="card-body">
    <h5 class="text-center">No images posted yet!</h5>
  </div>
</div>
